/* Require an explicit letter choice on ABC before its sticky can submit the product form. */
(() => {
  let confirmed = new URL(location.href).searchParams.has('variant');
  const labels = {
    de: 'Buchstaben wählen',
    en: 'Choose a letter',
    es: 'Elige la letra',
    fr: 'Choisissez la lettre',
    it: 'Scegli la lettera',
    pt: 'Escolhe a letra'
  };
  const lang = (document.documentElement.lang || 'en').slice(0, 2).toLowerCase();
  const label = labels[lang] || labels.en;
  let frame;
  function init() {
    const sticky = document.querySelector('[data-lpm-abc-sticky]');
    const buy = document.querySelector('[data-lpm-product="collar-letras-abc"]');
    if (!sticky || !buy) return;
    const primary = buy.querySelector('buy-buttons button[type="submit"]');
    const button = sticky.querySelector('button[type="submit"]');
    if (!primary || !button) return;
    if (!button.dataset.abcOriginal) button.dataset.abcOriginal = button.innerHTML;
    if (!confirmed) { if (button.textContent !== label) button.textContent = label; button.disabled = false; }
    else if (button.textContent === label) button.innerHTML = button.dataset.abcOriginal;
  }
  document.addEventListener('change', event => {
    if (!event.target.matches('[data-lpm-product="collar-letras-abc"] input[data-option-position="2"]')) return;
    confirmed = true;
    requestAnimationFrame(init);
  });
  document.addEventListener('click', event => {
    const button = event.target.closest('[data-lpm-abc-sticky] button');
    if (!button || confirmed) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    const picker = document.querySelector('[data-lpm-product="collar-letras-abc"] variant-picker fieldset:nth-of-type(2)');
    const choice = picker?.querySelector('input[data-option-position="2"]:checked, input[data-option-position="2"]:not(:disabled)');
    if (picker) {
      picker.scrollIntoView({ block: 'center', behavior: 'smooth' });
      setTimeout(() => choice?.focus({ preventScroll: true }), 250);
    }
  }, true);
  // Prestige replaces the native form and sticky bar after a variant selection.
  const rerender = document.querySelector('[data-lpm-abc-sticky]')?.closest('product-rerender')?.parentElement;
  if (rerender) new MutationObserver(() => {cancelAnimationFrame(frame);frame=requestAnimationFrame(init);}).observe(rerender,{childList:true,subtree:true});
  init();
})();
